<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form"
                          (confirmed)="onConfirmed($event)">
  <ifb-promotion-name-input [fc]="form.get('name')" baseFilterItem></ifb-promotion-name-input>
  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select formControlName="active"
                  placeholder="Status">
        <mat-option>All</mat-option>
        <mat-option [value]="'true'">Active</mat-option>
        <mat-option [value]="'false'">Inactive</mat-option>
      </mat-select>
    </mat-form-field>

  <ifc-filter-param-date-range-input [fc]="form.get('createdOn')" baseFilterItem
                                       [label]="'Created on'"
                                       (rangeSelected)="createdOnDateSelected($event)">
    </ifc-filter-param-date-range-input>
  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Product type</mat-label>
      <mat-select formControlName="productCode"
                  placeholder="All">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let option of productTypeOptions"
                    [value]="option.value">{{option.name}}</mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="form.get('createdOn').value === 'custom'">
  <ifc-datepicker [fc]="form.get('createdOnFrom')"
          [label]="'Created on from'" baseFilterItem></ifc-datepicker>
  <ifc-datepicker [fc]="form.get('createdOnTo')"
          [label]="'Created on to'" baseFilterItem></ifc-datepicker>
    </ng-container>

  <ifc-filter-param-date-range-input [fc]="form.get('startDate')" baseFilterItem
                                       [label]="'Start date'"
                                       (rangeSelected)="startDateSelected($event)">
    </ifc-filter-param-date-range-input>
  <ifc-filter-param-date-range-input [fc]="form.get('endDate')" baseFilterItem
                                       [label]="'End date'"
                                       (rangeSelected)="endDateSelected($event)">
    </ifc-filter-param-date-range-input>

    <ng-container *ngIf="form.get('startDate').value === 'custom'">
  <ifc-datepicker [fc]="form.get('startDateFrom')"
          [label]="'Start date from'" baseFilterItem></ifc-datepicker>
  <ifc-datepicker [fc]="form.get('startDateTo')"
          [label]="'Start date to'" baseFilterItem></ifc-datepicker>
    </ng-container>

    <ng-container *ngIf="form.get('endDate').value === 'custom'">
  <ifc-datepicker [fc]="form.get('endDateFrom')"
          [label]="'End date from'" baseFilterItem></ifc-datepicker>
  <ifc-datepicker [fc]="form.get('endDateTo')"
          [label]="'End date to'" baseFilterItem></ifc-datepicker>
    </ng-container>

  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Transaction type</mat-label>
      <mat-select formControlName="transactionType"
                  placeholder="All">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let option of transactionTypeOptions"
                    [value]="option.value">{{option.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Promotion type</mat-label>
      <mat-select formControlName="promotionType"
                  placeholder="All">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let option of promotionTypeOptions"
                    [value]="option.value">{{option.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </ifc-base-filter-dialog>
</form>
